<!-- eslint-disable @angular-eslint/template/no-call-expression -->
<web-design-system-modal [headline]="'investment-strategy.first-action-strategy-modal.headline' | transloco" (dismiss)="modal.dismiss()">
  <p class="zero-text p-base-reg">{{ 'investment-strategy.first-action-strategy-modal.text' | transloco }}</p>
  @if (store.notedStrategy(); as strategy) {
    <div class="zero-surface grey-800 b-r-8 p-3 mb-3">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center gap">
          <web-design-system-icon name="info" size="large" />
          <div class="zero-text p-base-med">{{ strategy.name }}</div>
        </div>
        <div class="zero-surface white b-r-8 px-3 py-2">
          <div class="d-flex justify-content-between gap-medium">
            <div class="d-flex flex-column align-items-center">
              <div class="zero-text p-xsmall-reg label">{{ 'investment-strategy.choice.return' | transloco }}</div>
              <div class="d-flex gap-half justify-content-center mt-1">
                <div class="dot filled-green"></div>
                <div class="dot" [class.filled-green]="['med', 'high'].includes(strategy.return)"></div>
                <div class="dot" [class.filled-green]="['high'].includes(strategy.return)"></div>
              </div>
            </div>
            <div class="d-flex flex-column align-items-center">
              <div class="zero-text p-xsmall-reg label">{{ 'investment-strategy.choice.risk' | transloco }}</div>
              <div class="d-flex gap-half justify-content-center mt-1">
                <div class="dot filled-red"></div>
                <div class="dot" [class.filled-red]="['med', 'high'].includes(strategy.risk)"></div>
                <div class="dot" [class.filled-red]="['high'].includes(strategy.risk)"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  <div class="d-flex justify-content-end gap-half">
    <web-design-system-button size="small" type="secondary" (click)="modal.dismiss()">{{
      'investment-strategy.first-action-strategy-modal.later' | transloco
    }}</web-design-system-button>
    <web-design-system-button size="small" type="primary" (click)="store.ackowledgeStrategy()" [disabled]="store.acknowledging()">{{
      'investment-strategy.first-action-strategy-modal.btn' | transloco
    }}</web-design-system-button>
  </div>
</web-design-system-modal>
